module.exports = __webpack_public_path__ + "img/phone3.47c4ba9f.png";